module.exports = __webpack_public_path__ + "static/media/microchip.377d2c98.svg";